import Enumerable from "linq";
import { RecipientTypeEnum } from "../../../../common/enums/RecipientTypeEnum";
import { AlarmNotificationsType, IAlarmNotificationObjectCountItemModel, IAlarmNotificationObjectCountModel } from "../../../../services/alarm-data-service/Models";
import { GraphItemOptions } from "../../../../services/trending-data-service/Models";
import { Options, PointOptionsObject, } from "highcharts";
import GraphUtils from "../../../../common/utilities/GraphUtils";
import { ActionMenuItem, BaseActions } from "../../../action-menu/ActionMenuItem";
import i18n from "../../../../services/localization-service/i18n";

const chartColors = [
    "#2ac8b4",
    "#767676",
    "#fe6d73",
    "#fee890",
    "#227c9d"
];

export const NOTIFICATION_CHART_MOUSE_EVENT = 'OBJECT_CHART_NOTIFICATIONS_MOUSE_EVENT'

export type NotificationsCountChartType = {

    options: GraphItemOptions,
    legendData: IAlarmNotificationObjectCountItemModel[]
}


export enum NotificationCountActions  {
    MoreInfo = 'moreinfo'
}

export type NotificationCountActionItem = {
    action: NotificationCountActions | BaseActions | string
} & ActionMenuItem;

export const notificationCountActionItems: NotificationCountActionItem[] = [{
    label: i18n.t("alarmDashboard.moreInfo"),
    //icon: () => <FontAwesomeIcon icon={faSquarePlus} size="1x" />,
    action: NotificationCountActions.MoreInfo,
    order: 0
}];


const NotificationsCountChartUtils = {

    getChartOptions: function(countsType: AlarmNotificationsType,
        objectCounts: IAlarmNotificationObjectCountModel,
        showText: boolean,
        showEmail: boolean,
        showVoice: boolean,
        onClick: (setpointName: string) => void,
        onMouseOver: (setpointName: string) => void,
        onMouseOut: (setpointName: string) => void,
    ): NotificationsCountChartType {


        const data = showText && showEmail && showVoice ?
                        objectCounts.objectCountItems :
                        objectCounts.objectCountItems.filter(o => (o.recipientType === RecipientTypeEnum.Text && showText) ||
                                                        (o.recipientType === RecipientTypeEnum.Voice && showVoice) ||
                                                        (o.recipientType === RecipientTypeEnum.Email && showEmail));
    
        const groupedData = Enumerable.from(data)
                            .groupBy(o => o.eLynxObject.objectName);



        let ndx = 0;

        const legendData = groupedData
            .select(o => {
                const firstItem: IAlarmNotificationObjectCountItemModel = o.first();
                const item = {
                    eLynxObject: firstItem.eLynxObject,
                    recipientType: firstItem.recipientType,
                    currentTimeframeCount: o.sum(x => x.currentTimeframeCount),
                    previousTimeframeCount: o.sum(x => x.previousTimeframeCount),
                    tagCount: firstItem.tagCount,
                    setPointCount: firstItem.setPointCount,
                    user: firstItem.user
                } as IAlarmNotificationObjectCountItemModel;
    
                return item;
            })
            .orderByDescending(o => o.currentTimeframeCount)
            .take(5)
            .toArray();
    
        legendData.forEach(item => item.color = chartColors[ndx++]);
    
        // this.setPointsLegendData = setPointsLegendData;
    
        const shapedData = groupedData
            .select(o => {
                const item = {
                    objectName: o.key(),
                    count: o.sum(x => x.currentTimeframeCount)
                };
    
                return item;
            })
            .orderByDescending(o => o.count)
            .toArray();
    
        ndx = 0;
        const seriesData = Enumerable.from(shapedData)
            .take(5)
            .select(o => {
                //const value: HighchartsDataPoint = {
                const value: PointOptionsObject = {
                    id: ndx.toString(),
                    //type: 'pie',
                    name: o.objectName,
                    y: o.count,
                    color: chartColors[ndx++],

                    events: {
                        click: function (event: Event) {

                            onClick(o.objectName as string);
    
                            //viewModel._onClickMostAlarmSPsSeries(this, event, viewModel);
                            return true;
                        },
                        mouseOver: function() {
                            onMouseOver(o.objectName as string);
                        },
                        mouseOut: function() {
                            onMouseOut(o.objectName as string);
                        }
                        //mouseOver: this._onSetPointsMouseOver,
                        //mouseOut: this._onSetPointsMouseOut
                    }
                };
                return value;
            }).toArray();
    
        // const options = this._getChartOptions("setpoint-most-alarms",
        //     "TOP 5 ALARM SETPOINTS",
        //     seriesData);
    
        //this._mostAlarmSetPointsChart = new Highcharts.Chart(options);

        const title = countsType === AlarmNotificationsType.Setpoints ?
                        `TOP 5 ALARM SETPOINTS` : 
                        countsType === AlarmNotificationsType.Objects ?
                        `TOP 5 ALARM OBJECTS` : 
                        `TOP 5 ALARM RECIPIENTS` ;

        const options: Options = {

            chart: {
                //renderTo: selector,
                plotShadow: false,
                type: "pie",
                borderWidth: 0,
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
            title: {
                text: title,
                align: "left",
                style: {
                    fontSize: ".95rem",
                    color: "#4c5f7b"
                }
            },
            tooltip: {
                pointFormat: '<b>{point.y}</b> {series.name}'
            },
            plotOptions: {
                pie: {
                    allowPointSelect: false,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: false,
                        format: '<b>{point.name}</b>: {point.y}'
                    },
                    borderColor: "transparent",
                    borderWidth: seriesData.length ? undefined : 0,
                }
            },
            series: [{
                name: 'Notifications',
                type: "pie",
                data: seriesData,
            }]
        };

        return {
            options: {...options,
                headerTitle: title,
                id: GraphUtils.getChartID(),
                index: 0
            },
            legendData: legendData
        } as NotificationsCountChartType;

    }


// private _renderMostAlarmSetPoints() {

//     if (this._mostAlarmSetPointsChart) {
//         this._mostAlarmSetPointsChart.destroy();
//         this._mostAlarmSetPointsChart = null;
//     }

//     this.setPointsLegendData = null;

//     const data = this.showText && this.showEmail && this.showVoice && this.allowVoiceAlarm ?
//         this._setpointCounts.objectCountItems :
//         this._setpointCounts.objectCountItems.filter(o => (o.recipientType === Enums.RecipientTypeEnum.Text && this.showText) ||
//             (o.recipientType === Enums.RecipientTypeEnum.Voice && this.showVoice && this.allowVoiceAlarm) ||
//             (o.recipientType === Enums.RecipientTypeEnum.Email && this.showEmail));

//     const groupedData = Enumerable.from(data)
//         .groupBy(o => o.eLynxObject.objectName);

//     let ndx = 0;
//     const setPointsLegendData = groupedData
//         .select(o => {
//             const firstItem: Models.IAlarmNotificationObjectCountItemModel = o.first();
//             const item = {
//                 eLynxObject: firstItem.eLynxObject,
//                 recipientType: firstItem.recipientType,
//                 currentTimeframeCount: o.sum(x => x.currentTimeframeCount),
//                 previousTimeframeCount: o.sum(x => x.previousTimeframeCount),
//                 tagCount: firstItem.tagCount
//             } as Models.IAlarmNotificationObjectCountItemModel;

//             return item;
//         })
//         .orderByDescending(o => o.currentTimeframeCount)
//         .take(5)
//         .toArray();

//     setPointsLegendData.forEach(item => item.color = this.chartColors[ndx++]);

//     this.setPointsLegendData = setPointsLegendData;

//     const shapedData = groupedData
//         .select(o => {
//             const item = {
//                 setPointName: o.key(),
//                 count: o.sum(x => x.currentTimeframeCount)
//             };

//             return item;
//         })
//         .orderByDescending(o => o.count)
//         .toArray();

//     //const groupedData = data.reduce(function (acc, obj) {
//     //    const key = obj["setPointName"]
//     //    if (!acc[key]) {
//     //        acc[key] = [];
//     //    }
//     //    acc[key].push(obj)
//     //    return acc
//     //}, {});

//     const viewModel: AlarmNotificationsDashoardViewViewModel = this;

//     ndx = 0;
//     const seriesData = Enumerable.from(shapedData)
//         .take(5)
//         .select(o => {
//             const value: HighchartsDataPoint = {
//                 id: ndx.toString(),
//                 name: o.setPointName,
//                 y: o.count,
//                 color: this.chartColors[ndx++],
//                 events: {
//                     click: function (event: Event) {

//                         viewModel._onClickMostAlarmSPsSeries(this, event, viewModel);
//                         return true;
//                     },
//                     mouseOver: this._onSetPointsMouseOver,
//                     mouseOut: this._onSetPointsMouseOut
//                 }
//             };
//             return value;
//         }).toArray();

//     const options = this._getChartOptions("setpoint-most-alarms",
//         "TOP 5 ALARM SETPOINTS",
//         seriesData);

//     this._mostAlarmSetPointsChart = new Highcharts.Chart(options);
// }



// private _renderMostAlarmObjects() {

//     if (this._mostAlarmDevicesChart) {
//         this._mostAlarmDevicesChart.destroy();
//         this._mostAlarmDevicesChart = null;
//     }

//     this.objectsLegendData = null;

//     const data = this.showText && this.showEmail && this.showVoice && this.allowVoiceAlarm ?
//         this._objectNotificationCounts.objectCountItems :
//         this._objectNotificationCounts.objectCountItems.filter(o => (o.recipientType === Enums.RecipientTypeEnum.Text && this.showText) ||
//             (o.recipientType === Enums.RecipientTypeEnum.Voice && this.showVoice && this.allowVoiceAlarm) ||
//             (o.recipientType === Enums.RecipientTypeEnum.Email && this.showEmail));

//     const groupedData = Enumerable.from(data)
//         .groupBy(o => o.eLynxObject.objectName);

//     let ndx = 0;
//     const objectsLegendData = groupedData
//         .select(o => {
//             const firstItem: Models.IAlarmNotificationObjectCountItemModel = o.first();
//             const item = {
//                 eLynxObject: firstItem.eLynxObject,
//                 recipientType: firstItem.recipientType,
//                 currentTimeframeCount: o.sum(x => x.currentTimeframeCount),
//                 previousTimeframeCount: o.sum(x => x.previousTimeframeCount),
//                 setPointCount: firstItem.setPointCount
//             } as Models.IAlarmNotificationObjectCountItemModel;

//             return item;
//         })
//         .orderByDescending(o => o.currentTimeframeCount)
//         .take(5)
//         .toArray();

//     objectsLegendData.forEach(item => item.color = this.chartColors[ndx++]);

//     this.objectsLegendData = objectsLegendData;

//     const shapedData = groupedData
//         .select(o => {
//             const item = {
//                 objectName: o.key(),
//                 count: o.sum(x => x.currentTimeframeCount)
//             };

//             return item;
//         })
//         .orderByDescending(o => o.count)
//         .toArray();

//     const viewModel: AlarmNotificationsDashoardViewViewModel = this;

//     ndx = 0;
//     const seriesData = Enumerable.from(shapedData)
//         .take(5)
//         .select(o => {
//             const value: HighchartsDataPoint = {
//                 id: ndx.toString(),
//                 name: o.objectName,
//                 y: o.count,
//                 color: this.chartColors[ndx++],
//                 events: {
//                     click: function (event: Event) {

//                         viewModel._onClickMostAlarmObjectsSeries(this, event, viewModel);
//                         return true;
//                     },
//                     mouseOver: this._onObjectsMouseOver,
//                     mouseOut: this._onObjectsMouseOut
//                 }
//             };
//             return value;
//         }).toArray();

//     const options = this._getChartOptions("device-most-alarms",
//         "TOP 5 ALARM OBJECTS",
//         seriesData);

//     this._mostAlarmDevicesChart = new Highcharts.Chart(options);
// }

}

export default NotificationsCountChartUtils;